import { h, Component } from 'preact';
import cx from 'classnames';
import getStore, { appState$ } from '../../store';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Listing } from '../../../../types';
import { GET_API_PROPERTY, GET_LISTING_DETAIL } from '../../reducers/listing/listing.actions';
import { hopplerApi, PHOTO_PARAMS } from '../../../../constants';
import { toDecimal } from '../../../../core/decimal';

export interface PropertyPreviewProps {
  propertykey?: string;
}

export interface PropertyPreviewState {
  focusedListing?: Listing;
  isDescriptionOpen?: boolean;
}

export class PropertyPreview extends Component<PropertyPreviewProps, PropertyPreviewState> {
  private subs: Subscription[] = [];
  
  constructor(props: PropertyPreviewProps) {
    super(props);
  }

  componentDidMount() {

    const listings$ = appState$.pipe(
      map(app => app.listing)
    );

    this.subs.push(
      listings$.pipe(
        map(listing => listing.focusedListing),
        distinctUntilChanged()
      ).subscribe(focusedListing => {
        this.setState({
          focusedListing: focusedListing
        })
      })
    );

    this.initialStoreDispatches();
  }

  initialStoreDispatches() {
    const store = getStore();

    store.dispatch({
      type: GET_LISTING_DETAIL,
      payload: {
        focusedPropertyKey: this.props.propertykey.toUpperCase()
      }
    });
  }

  onDescriptionToggle = () => {
    this.setState({
      isDescriptionOpen: !this.state.isDescriptionOpen
    })
  }

  getCarousel(props: PropertyPreviewProps, state: PropertyPreviewState) {
    return (
      <div className="hi-listing-page__carousel-container" id="hiListingCarouselContainer">
        {/* PRESELLING FLAG HERE */}

        <div className="hi-listing-page__carousel hi-listing-page__carousel-property carousel slide hi-lazy"
          id="hiListingCarousel">

          {/* <div className="hi-listings-page__carousel-toggle">
            <button className="btn btn-outline-dark hi-listings-page__carousel-toggle-btn"
              data-hi-class-toggle="building" data-target='hiListingCarouselContainer'>
              View Building Photos
            </button>
          </div> */}
          
          <ol className="carousel-indicators">
            { state.focusedListing.multimedia ? state.focusedListing.multimedia.map( (photo, index) => 
              <li data-target="#hiListingCarousel" data-slide-to={ index }
                className={ index == 0 ? 'active' : '' }>
              </li>
            ) : null
          }
          </ol>

          <div className="carousel-inner">
            { state.focusedListing.multimedia ? state.focusedListing.multimedia.map( (photo, index) => 
              <div className={ 'carousel-item ' + (index == 0 ? 'active' : '') }>
                <img className="hi-listing-page__carousel-img"
                  data-src={ `${hopplerApi.images}/${photo.media}?${PHOTO_PARAMS}` }
                  src={ `${hopplerApi.images}/${photo.media}?${PHOTO_PARAMS}` }/>
              </div>
            ) :
            <div className='carousel-item active'>
              <img className="hi-listing-page__carousel-img"
                src={ `${hopplerApi.images}/noPhoto02.png?${PHOTO_PARAMS}` }/>
            </div>
          }
          </div>
          <a href="#hiListingCarousel" className="carousel-control-prev" 
            role='button' data-slide='prev'>
            <span className="carousel-control-prev-icon" aria-hidden="true">
            </span>
            <span className="sr-only">Previous</span>
          </a>
          <a href="#hiListingCarousel" className="carousel-control-next" 
            role='button' data-slide='next'>
            <span className="carousel-control-next-icon" aria-hidden="true">
            </span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    )
  }

  getResidentialDetails(props: PropertyPreviewProps, state: PropertyPreviewState) {
    let listing = state.focusedListing;

    if (listing.division === 'Residential') {
      return (
        <div className="hi-listing-page__key-stats row no-gutters">
          <div className="col col-lg-4">
            <div className="hi-listing-page__key-stats__stat">
              { listing.bedrooms == 0 ? 'Studio' : listing.bedrooms + ' Bedrooms' }
            </div>
          </div>
          <div className="col col-lg-4">
            <div className="hi-listing-page__key-stats__stat">
              { listing.bathrooms > 1 ? listing.bathrooms + ' Bathroom' : listing.bathrooms + 'Bathrooms' }
            </div>
          </div>
        </div>
      )
    }

  }

  getRightSide(props: PropertyPreviewProps, state: PropertyPreviewState) {
    let listing = state.focusedListing;

    return (
      <div className="hi-listing-page__right-section">
        <div className="hi-listing-page__right-section-property-info px-3 py-3">
          {
            listing.preSale ?
            <span className="hi-listing-page__starts-at">
              Starts at
            </span> : null
          }
          {
            listing.preSale ?
            <span className="hi-listing-page__price">
              Php { toDecimal(listing.salePrice | listing.rentalPrice) }
            </span> : null
          }
          {
            !listing.preSale ?
            <span className="hi-listing-page__price">
              Php { toDecimal(listing.salePrice | listing.rentalPrice | listing.pricePerSqm) }
              {
                listing.division === 'Commercial' ?
                <span className="hi-listing-page__price-per-sqm">
                  /sqm
                </span> : null
              }
            </span> : null
          }
          {
            !listing.preSale && listing.category === 'Rent' ?
            <span className="hi-listing-page__price-suffix">
              /month
            </span> : null
          }

          <div className="hi-listing-page__property-key mb-2 mt-3">
            <strong>
              { listing.propertyKey } (Property ID)
            </strong>
          </div>

          {
            this.getResidentialDetails(props, state)
          }

          <div className="hi-listing-page__key-stats row no-gutters">
            {
              listing.floorArea ? 
              <div className="col col-lg-4">
                <div className="hi-listing-page__key-stats__stat">
                  { listing.floorArea } sqm
                </div>
              </div> : null
            }
            {
              listing.lotArea ? 
              <div className="col col-lg-4">
                <div className="hi-listing-page__key-stats__stat">
                  { listing.lotArea } sqm
                </div>
              </div> : null
            }
          <div className="col col-lg-4">
            <div className="hi-listing-page__key-stats__stat">
              { listing.furnishing }
            </div>
          </div>
        </div>
        </div>
        
      </div>
    );

  }

  getPropertyPreview(props: PropertyPreviewProps, state: PropertyPreviewState) {
    let listing = state.focusedListing;

    return (
      <div className="hi-kumita__property-preview">

        <div className="hi-kumita__property-preview__listing-container">

            <div className="hi-listing-page py-4">
              <div className="container">

                <div className="hi-listing-page__heading-row--desktop row">
                  <div className="col-12 col-lg-9">
                    <span className="hi-listing-page__h1 hi-listing-page__h1--top-heading">
                      { listing.bedrooms > 0 ? listing.bedrooms + ' BR' : 'Studio' } { listing.type } for { listing.category } in { listing.area }, { listing.city }
                    </span>
                  </div>
                  <div className="col-12">
                    <span className="hi-type-caption">{ listing.area }, { listing.city }</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-8">
                    { this.getCarousel(props, state) }

                    <div className="hi-listing-page__main-details d-flex flex-column">
                      <div className="d-none d-md-flex row">
                        <div className="col-2">
                          <span className="hi-type-caps pt-0">About the Property</span>
                        </div>
                        <div className="col-9 offset-1">
                          <div
                            className={ cx('hi-listing-page__description', {'opened': state.isDescriptionOpen}) } 
                            id="hiDescriptionDesktop">
                            { listing.description }
                          </div>
                          <button className="btn btn-link hi-listing-page__description-read-more"
                              onClick={this.onDescriptionToggle}>
                            Read more about the property 
                            <i className="fa fa-angle-down"></i>
                          </button>
                        </div>
                      </div>

                      {
                        listing.amenities && listing.amenities.length > 0 ?
                        <div className="order-md-0 row mt-3">
                          <div className="col-md-2">
                            <span className="hi-type-caps pt-0">
                              Amenities
                            </span>
                          </div>
                          <div className="col-md-9 offset-md-1">
                            <div className="row">
                              {
                                listing.amenities.map((amenity, index) => {
                                  if (amenity.value) {
                                    if (amenity.field === 'Parking Spaces') {
                                      return (
                                        <div className="col-6">
                                          { amenity.value } { amenity.field }
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <div className="col-6">
                                          { amenity.field }
                                        </div>
                                      );
                                    }
                                  }
                                })
                              }
                            </div>
                          </div>
                        </div> : null
                      }
                    </div>

                  </div>

                  <div className="col-lg-4">
                    { this.getRightSide(props, state) }
                  </div>

                </div>
              </div>
            </div>
          </div>
            
      </div>
    );
  }
  
  render(props: PropertyPreviewProps, state: PropertyPreviewState) {
    if (state.focusedListing) {
      // return (
      //   <div>
      //     <PropertyPage listing={state.focusedListing}/>
      //   </div>
      // );
      return this.getPropertyPreview(props, state);
    } else {
      return (
        <div>
          Loading...
        </div>
      )
    }
  }
}